<template>
  <div>
    <div class="uploader ready illustrator-container">
      <div
        class="upload-drop-site upload-drop-site-wrapper"
        :id="'illu-' + id"
      >
        <div class="upload-image-container" v-if="photos && photos.length === 0">
          <div class="image-upload">
            <VPhotoInput
              ref="photoInput1"
              name="carImagesInterior"
              :onInputFiles="onInputFiles"
            />
          </div>
          <div class="image-upload camera-upload d-block d-md-none">
            <VCameraInput
              ref="photoInput1"
              name="carCaptureImagesInterior"
              :onInputFiles="onInputFiles"
            />
          </div>
          <!-- <div class="image-upload-qrcode d-none d-md-block" @click="qrCodeModelToggle"> -->
           
          <!-- </div> -->
        </div>
        <div class="handler position-relative">
          <template>
            <div class="" v-if="photos && photos.length === 0">
              <img :src="getImage(id)" alt="Illustrator SVG" class="handler__image" />
              <div
                class="illustration-image-number-container position-absolute"
                v-if="isShowNumber"
              >
                <span class="">
                  {{ number }}
                </span>
              </div>
            </div>
            <div class="position-relative preview-wrapper" v-if="photos && photos.length > 0" style="height: 100%; width: 100%;">
              <div class="preview" v-for="photo in photos" :key="'image-'+`${photo.id}`">
                <VPhotoPreview :image="photo.file" :loading="photo.loading" :type="photo.type" :mainImage="photo.mainImage" />
                <button
                  v-if="!photo.loading"
                  type="button"
                  class="btn remove photo-input__remove-btn"
                  :class="{
                    'photo-input__remove-btn_deleting': photo.deleting
                  }"
                  aria-label="Delete"
                  @mouseup="removePhoto(photo)"
                >
                  <span class="sr-only">Delete</span>
                </button>
                <div class="image-checkbox-container">

                  <CInputCheckbox
                    class="car-manager__row-checkbox"
                    size="lg"
                    :name="'checkbox-name'+ photo.id"
                    custom
                    :key="`${photo.id}`"
                    :id="`${photo.id}`"
                    :checked="photo && photo.result && photo.result.mainImage && (photo.result.mainImage === 1 || photo.result.mainImage === true) ? true:false"
                    @change="onChangeCheckBoxInput" 
                  />
                </div>
              </div>
            </div>
            
          </template>
        </div>
      </div>
    </div>
    <div v-if="isCropModalOpen">
      <ImageCropModal :imageSrc="imageSrc" :closeCurrentModal="closeCurrentModal" :uploadFiles="uploadFiles" :imageName="imageName" />
    </div>
    <!-- <div v-if="isQrCodeShow">
      <QRCodeComponent :qrCodeModelToggle="qrCodeModelToggle" :qrValue="qrValue" />
    </div> -->
  </div>
</template>
<script>
import { checkImageOrFail } from "@/utils/validation/image";
import VPhotoPreview from "./VPhotoPreview";
import VPhotoInput from "./VPhotoInput";
// import QRCodeComponent from './QRCodeComponent.vue'
// import {
//   createMixin as createCarApiMixin,
//   carActionTypes,
//   carGetterTypes
// } from "@/mixins/carsApiMixin";
import VCameraInput from "./VCameraInput.vue";
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import ImageCropModal from "@/components/ImageCropModal.vue";
export default {
  name: "VIllustrationImage",

  mixins: [createAuctionManagerMixin()],

  components: {
    VPhotoPreview,
    VPhotoInput,
    ImageCropModal,
    // QRCodeComponent,
    VCameraInput
},

  props: {
    name: {
      type: String,
      default: ""
    },
    minCount: {
      type: Number,
      default: 1
    },
    // errorMsg: {
    //   type: String
    // },
    id: {
      type: Number
    },
    carId: {
      type: Number
    },
    number: {
      type: Number
    },
    isShowNumber: {
      type: Boolean
    },
    images: {
      type: Array
    },
    imageIds: {
      type: Array
    },
    qrValue: {
      type: String
    },
    imageType: {
      type: String
    },
    uploadedImages:{type: Array}
  },

  computed: {
  },

  data: () => ({
    imageName: null,
    imageSrc: null,
    isCropModalOpen: false,
    isActiveDragEvent: false,
    photos: [],
    errorList: [],
    allFilesCount: 1,
    morePhotos: 0,
    showError: false,
    isQrCodeShow: false
  }),

  methods: {
    closeCurrentModal(){
      this.isCropModalOpen = false;
      this.imageName = null
    },
    async onChangeCheckBoxInput($event){
      let photo = this.photos.find(x => x.id ===  Number($event.target.id))
      photo.result.mainImage = $event.target.checked
      await this[auctionManagerStore.actionTypes.ACTION_PAGE_REOLAD](false)
       this[auctionManagerStore.actionTypes.ACTION_CAR_FEATURED_IMAGE]({ carId: photo.result.carId, mainImage: $event.target.checked, imageId: photo.result.id }).then((isSuccess) => {
        this.$emit("onUpdateMainImage", photo);
       })
    },
    qrCodeModelToggle(){
      this.isQrCodeShow = !this.isQrCodeShow
    },
    getImage(id) {
      return `https://evbids.blob.core.windows.net/assets/images/illustrator${id}.svg`;
    },
    hasErrors() {
      this.showError = this.photos.length < this.minCount;
      if (this.photos.length < this.minCount) {
        this.showError = true;
      }

      if (this.showError) {
        this.morePhotos = this.minCount - this.photos.length;
        this.$nextTick(() => {
          this.$refs.errorText.focus();
        });
      }

      return this.showError;
    },
    onInputFiles(e) {
      debugger
      const file = e.target.files[0];
      this.imageName = file.name;
      if (file) {
        // Read the selected image file and set it as the cropper source
        const reader = new FileReader();
        reader.onload = () => {
          debugger
          this.imageSrc = reader.result;
          this.isCropModalOpen = true;
        };
        reader.readAsDataURL(file);
      }
      // this.uploadFiles(e.target.files);
    },
    async uploadFiles(files) {
      this.isCropModalOpen = false
      this.imageName = null

      for (let idx = 0; idx < Array.from(files).length; idx++) {
        try {
          checkImageOrFail(files[idx]);
          const newPhoto = {
            id: this.id,
            file: files[idx],
            loading: true,
            deleting: false,
            result: null,
            type: 'file'
          };
          this.photos.push(newPhoto);
          debugger
          console.log("this.imageType",this.imageType)
          console.log("this.carId",this.carId)
          console.log("this.id",this.id)
          this[auctionManagerStore.actionTypes.ACTION_ADD_PHOTO_TO_JOINED_CAR]({
            idx: newPhoto.id,
            file: files[idx],
            name: this.imageType,
            carId: this.carId,
            illustratorId: this.id,
          })
            .then(({ arrId,uploadImageId, data }) => {
              const index = this.photos.findIndex(f => f.id === arrId);
              // eslint-disable-next-line vue/no-mutating-props
              this.images.push({id: this.id, uploadImageId: uploadImageId, image: files[idx], type: this.imageType, imageType: 'file'})
              
              this.photos.splice(index, 1, {
                ...this.photos[index],
                result: data,
                // file: files[idx],
                type: 'file',
                loading: false
              });

            })
            .catch((err) => {
              const index = this.photos.findIndex(f => f.id === this.id);
              if(index > -1){
                this.photos.splice(index, 1)
              }
            });
        } catch (error) {
          this.pushError(error.message);
        }
      }

      this.$emit("input", files);
    },
    hasLoadingPhotos() {
      return this.photos.some(p => p.loading);
    },

    getFileId() {
      this.allFilesCount = 1;
      return this.allFilesCount;
    },

    pushError(errorText) {
      this.errorList.push(errorText);

      setTimeout(() => {
        this.removeItemFromArray(this.errorList, errorText);
      }, 5000);
    },

    async removePhoto(photo) {
      if (!photo.result || !photo.result.id || photo.deleting) return;
      photo.deleting = true;
      await this[auctionManagerStore.actionTypes.ACTION_REMOVE_CAR_PHOTO]({
        imageId: photo.result.id
      });
      photo.deleting = false;
      this.removeItemFromArray(this.photos, photo, true);
      let cloneImage = [...this.images]
      let findIndex = cloneImage.findIndex(x =>x.id === this.id);
      if(findIndex > -1){
        cloneImage.splice(findIndex, 1)
        // eslint-disable-next-line vue/no-mutating-props
        this.images = cloneImage
      }
    },

    removeItemFromArray(array, item, isPhoto) {
      const itemIndex = isPhoto
        ? array.findIndex(_item => _item.id === item.id)
        : array.indexOf(item);

      if (itemIndex >= 0) {
        array.splice(itemIndex, 1);
      }
    }
  },
  mounted(){
    if(this.uploadedImages && this.uploadedImages.length > 0){
      for(let i =0; i < this.uploadedImages.length; i++){
        if(this.id === this.uploadedImages[i].illustratorId){
           // eslint-disable-next-line vue/no-mutating-props
          this.images.push({id: this.id, uploadImageId: this.uploadedImages[i].id, image: this.uploadedImages[i].url, type: this.imageType, imageType: 'url'})
          const newPhoto = {
            id: this.id,
            file:this.uploadedImages[i].url,
            loading: false,
            deleting: false,
            type: 'url',
            result: this.uploadedImages[i]
          };
          this.photos.push(newPhoto);
        }

      }
      console.log("mounted", this.photos)
    }
  }
};
</script>
<style>
.photo-input__remove-btn {
  z-index: 3;
  position: absolute;
    top: 5px;
    right: 15px;
    padding: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: #989292;
    width: 25px;
    height: 25px;
    border-radius: 50% !important;
    opacity: 0.6;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
}
.photo-input__remove-btn::after{
  margin-top: -1px;
    content: "";
    background: transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgBrdIBDYYgEAVg+Iv8RrCBNsEGRrCKEbSBTYxghOdtDgfT457OtzHcwX1TwbmP4uMDgF6mWsbsvZ+YZunpZGpkLGcBeQKBDGlDLI64JrBICrW4T2AQyZp9r4VpiIzq8vM0jEYIjEceYDZCYLfIr2D9lXrljktIvc0AO+ENsj3CUDhiEPfMRJI9ZUzZkCEWFhdHBilhcaFlEQXbdrDHoT5X4lsRAAAAAElFTkSuQmCC) no-repeat 0 0/100%;
    width: 9px;
    height: 9px;
    display: block;
}
.photo-input__remove-btn_deleting::after {
  margin-top: 0 !important;
  background: none !important;
  width: calc(100% - 4px) !important;
  height: calc(100% - 4px) !important;
  border: solid;
  border-radius: 50em;
  border-right: 0.25em solid white;
  animation: spinner-border 0.75s linear infinite;
}
.illustrator-container .upload-drop-site.upload-drop-site-wrapper {
  border-radius: 15px;
  border: 1px solid #dddddd !important;
  height: 140px;
  background: #fff;
}
.illustration-image-number-container {
  top: 6px;
  left: 6px;
  background: black;
  color: #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  text-align: center;
}
.illustration-image-number-container span {
  vertical-align: text-top;
}
.upload-image-container {
  display: flex;
  justify-content: space-between;
  background-color: #f0f0f0;
  border-radius: 8px;
  position: absolute;
  top: 10px;
  right: 25px;
  display: none;
  padding: 0px, 2px, 0px, 2px;
  margin-right: 24px;
  width: 32px;
  height: 32px;
  z-index: 1;
  @media (max-width: 767px) {
    width: 68px;
    right: 20;
  }
  @media (max-width: 767px) {
    width: 68px;
    right: 20;
  };
  @media (max-width: 500px) {
    width: 68px;
    right: 15;
  }
}
.upload-drop-site:hover .upload-image-container {
  display: flex;
}
.image-upload {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/image-upload-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/image-upload-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #e1f3cb;
  background-position: center;
  border-radius: 8px;
}
.camera-upload{
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload.camera-upload:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #e1f3cb;
  background-position: center;
  border-radius: 8px;
}
.image-upload-qrcode {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-inactive.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center;
}
.image-upload-qrcode:hover {
  width: 32px;
  height: 32px;
  background: url(https://evbids.blob.core.windows.net/assets/images/camera-active.svg);
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-color: #e1f3cb;
  background-position: center;
  border-radius: 8px;
}
.image-checkbox-container{
  position: absolute;
    z-index: 3;
    left: 15px;
    top: 5px;
}
</style>
